var r = /* @__PURE__ */ ((c) => (c.Clickable = "clickable", c.Icon = "icon", c))(r || {});
export {
  r as LeftElementType
};
